import { createTheme, ThemeProvider } from '@mui/material/styles';
import { lime, purple } from '@mui/material/colors';

import Arista  from './fonts/Arista-Pro-Light-trial.ttf';

import './App.css';
import './i18n'

import Layout from './routes/Layout'


const theme = createTheme({
  typography: {
    fontFamily: [
      'Arista-Pro-Light-trial',
      'Arista-Pro-Fat-trial',
      'Arista-Pro-Bold-trial',
      'Arista-Pro-Alternate-Light-trial',
      'Arista-Pro-Alternate-Fat-trial',
      'Arista-Pro-Alternate-Bold-trial',
      'Nexa-BlackItalic',
      'Nexa-Black',
      'Nexa-Bold',
      'Nexa-BoldItalic',
      'Nexa-Book',
      'Nexa-BookItalic',
      'Nexa-Heavy',
      'Nexa-HeavyItalic',
      'Nexa-Italic',
      'Nexa-LightItalic',
      'Nexa-Light',
      'Nexa-Regular',
      'Nexa-ThinItalic',
      'Nexa-Thin',
      'Nexa-XBoldItalic',
      'Nexa-XBold',
      '-apple-system',
      '"Apple Color Emoji"',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(','),
  },
  palette: {
    primary: {
      main: '#53392a',
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary:{
      main: '#075f37',
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    red: {
      main: '#ff0000',
    },
    orange: {
      main: '#eca400',
    },
    beige: {
      main: '#f6ffda',
    },
    green: {
      main: '#075f37'
    },
    brown: {
      main: '#53392a'
    },
  },
  components: {
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: '#075f37',
            color: "white",
          }
        }
      },
      MuiCard: {
      styleOverrides: {
        root: {
          // Some CSS
          borderColor: "orange",
          borderRadius: 50,
          position: "relative",
          zIndex: 0,
        },
      },
    },
    }
});

function App() {
  return (

    <ThemeProvider theme={theme}>
      <Layout />
    </ThemeProvider>
    
  );
}

export default App;
